"use client";

import { useState } from "react";
import { Modal } from "@/scott/ui/blocks/modal/modal";
import { Button } from "@/scott/ui/elements/button/button";

interface ProductStoreFinderModalProps {
  iframeUrl: string;
  microcopies: {
    buttonLabel: string;
    buttonSubtitle?: string;
    title: string;
  };
}

export function ProductStoreFinderModal(
  props: Readonly<ProductStoreFinderModalProps>
) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button
        className="h-[71px] w-full flex-col items-start justify-between rounded border border-alabastergrey p-3"
        onClick={() => setIsOpen(true)}
        type="button"
        variant="outline"
      >
        <span className="font-bold font-brand text-[12px] text-black leading-[14px] tracking-[0.02em]">
          {props.microcopies.buttonLabel}
        </span>
        {props.microcopies.buttonSubtitle && (
          <span className="font-brand font-normal text-[12px] text-black leading-[17px] tracking-normal">
            {props.microcopies.buttonSubtitle}
          </span>
        )}
      </Button>

      <Modal
        contentClassName="h-[70vh] p-0 overflow-hidden"
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title={props.microcopies.title}
      >
        <iframe
          allow="geolocation"
          className="h-full w-full border-0"
          loading="lazy"
          src={props.iframeUrl}
          title={props.microcopies.title}
        />
      </Modal>
    </>
  );
}
